// extracted by mini-css-extract-plugin
module.exports = {"container":"StorageInformation_container__1kxbB"};